import React from 'react'
import { useHistory } from 'react-router-dom'
import { useController } from 'react-hook-form'

import { ReactComponent as SortAsc } from 'assets/icons/sort.asc.svg'
import { ReactComponent as SortDesc } from 'assets/icons/sort.desc.svg'

import { maskDate } from 'util/masks'
import { useFormZod } from 'hooks/useFormZod'

import { getBucketItems } from '../service/store.service'
import { getDefaultStorageItemsFilter } from '../hooks/getDefaultFilters'
import { GetStorageListOrder, GetStorageListOrderDirection } from '../schema/storage.items-filter.schema'
import { GetStorageListPropsSchema, GetStorageListPropsSchemaType } from '../schema/storage.items-filter.schema'

export const StorageItemFilter: React.FC = () => {
  const history = useHistory()
  const searchParams = new URLSearchParams(history.location.search)

  const filter = getDefaultStorageItemsFilter()
  getBucketItems(filter)
  const { control, handleSubmit } = useFormZod(GetStorageListPropsSchema, filter)

  const end = useController({ control, name: 'filter.date.end' })
  const name = useController({ control, name: 'filter.name' })
  const start = useController({ control, name: 'filter.date.start' })
  const limit = useController({ control, name: 'limit' })
  const orderBy = useController({ control, name: 'order.by' })
  const orderDirection = useController({ control, name: 'order.direction' })

  const handleFilter = (data: GetStorageListPropsSchemaType) => {
    searchParams.set('page', '1')
    searchParams.set('limit', String(data.limit))
    if (data.filter) {
      if (data.filter.name) searchParams.set('filter.name', data.filter.name)
      if (data.filter.date?.start) searchParams.set('filter.date.start', data.filter.date.start)
      if (data.filter.date?.end) searchParams.set('filter.date.end', data.filter.date.end)
    }

    if (searchParams.has('filter.name') && !data.filter?.name) {
      searchParams.delete('filter.name')
    }

    if (searchParams.has('filter.date.start') && !data.filter?.date?.start) {
      searchParams.delete('filter.date.start')
    }

    if (searchParams.has('filter.date.end') && !data.filter?.date?.end) {
      searchParams.delete('filter.date.end')
    }

    searchParams.set('order.by', data.order.by)
    searchParams.set('order.direction', data.order.direction)
    history.push(`${history.location.pathname}?${searchParams.toString()}`)
  }

  return (
    <form
      className="row panel bordered"
      style={{
        width: '100%',
        display: 'grid',
        alignItems: 'end',
        gridTemplateColumns: '1fr 150px 150px 100px 200px 90px'
      }}
      onSubmit={handleSubmit(handleFilter, console.log)}
    >
      <div className="form-control">
        <label>Nome</label>
        <input
          value={name.field.value || ''}
          onChange={(e) => { name.field.onChange(e.target.value.trim()) }}
        />
      </div>
      <div className="form-control">
        <label>Data Início</label>
        <input
          value={start.field.value || ''}
          onChange={(e) => { start.field.onChange(maskDate(e.target.value)) }}
        />
      </div>
      <div className="form-control">
        <label>Data Fim</label>
        <input
          value={end.field.value || ''}
          onChange={(e) => { end.field.onChange(maskDate(e.target.value)) }}
        />
      </div>
      <div className="form-control">
        <label>Quantidade</label>
        <select
          value={limit.field.value}
          onChange={e => {
            limit.field.onChange(Number(e.target.value))
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
          <option value={300}>300</option>
          <option value={400}>400</option>
          <option value={500}>500</option>
        </select>
      </div>
      <div className="form-control">
        <label>Ordenar por</label>
        <div
          style={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns: '1fr 42px',
            gap: 4,
            justifyItems: 'center',
            alignItems: 'center'
          }}
        >
          <select value={orderBy.field.value} onChange={e => orderBy.field.onChange(e.target.value)}>
            <option value={GetStorageListOrder.DATE}>Data</option>
            <option value={GetStorageListOrder.SIZE}>Tamanho</option>
          </select>
          {
            orderDirection.field.value === GetStorageListOrderDirection.ASC
              ? (
                <SortAsc
                  style={{ width: 22, cursor: 'pointer' }}
                  onClick={() => orderDirection.field.onChange(GetStorageListOrderDirection.DESC)}
                />
              )
              : (
                <SortDesc
                  style={{ width: 22, cursor: 'pointer' }}
                  onClick={() => orderDirection.field.onChange(GetStorageListOrderDirection.ASC)}
                />
              )
          }
        </div>
      </div>
      <button className="primary" style={{ height: 48 }}>
        <i className="fa fa-filter" />
      </button>
    </form>
  )
}
